import { render, staticRenderFns } from "./PublishComponent.vue?vue&type=template&id=2c4fb25a"
import script from "./PublishComponent.vue?vue&type=script&lang=js"
export * from "./PublishComponent.vue?vue&type=script&lang=js"
import style0 from "./PublishComponent.vue?vue&type=style&index=0&id=2c4fb25a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports